import { Route } from '@angular/router';
import { LoginGuard, PermissionGuard } from '@simac/ui';

export const RetourReceiveRoute: Route = {
  path: 'retour/receive',
  children: [
    {
      path: '',
      loadComponent: () => import('./pages/receive.component').then((m) => m.ReceiveComponent),
    },
  ],
  canActivate: [LoginGuard, PermissionGuard],
};
